/** All enquiries route through the Waydev contact desk. */
export const WAYDEV_CONTACT_URL = 'https://waydev.co/contact/'

export const contactDetails: { key: string; value: string; href?: string }[] = [
  {
    key: 'Enquiries',
    value: 'waydev.co/contact',
    href: WAYDEV_CONTACT_URL,
  },
  {
    key: 'LinkedIn',
    value: '/in/alexcircei',
    href: 'https://www.linkedin.com/in/alexcircei/',
  },
  { key: 'X', value: '@AlexCircei', href: 'https://x.com/AlexCircei' },
  { key: 'GitHub', value: '/alexcircei', href: 'https://github.com/alexcircei' },
  { key: 'Company', value: 'waydev.co', href: 'https://waydev.co' },
  { key: 'Offices', value: 'San Francisco, California / New York, NY' },
  { key: 'Availability', value: 'A small number of engagements each year' },
]
